export default __webpack_public_path__ + "f31518cf2dce4245f09f6e121ce3ca5c.ttf";